// extracted by mini-css-extract-plugin
export default {"container":"PtQw","blockHeader":"XHJT","rangesWrapper":"SEyT","rangeWrapper":"sw9l","range":"AwUq","remove":"hmVg","actions":"YVLx","btn":"aSO9"};